export function uriDecodeData(data) {
    for (let key in data) { // eslint-disable-line no-unused-vars
        if (typeof data[key] == 'object') {
            data[key] = uriDecodeData(data[key])
        } else if (typeof data[key] == 'string') {
            data[key] = decodeURIComponent(data[key])
        }
    }
    return data
}

/**
* Get times in str from time in ms.
* @param timeInMs  time in ms
*/
export function getStrTime(timeInMs, t, displaySeconds=true, queue={
    days: 'queue.days',
    minutes: 'queue.minutes',
    hours: 'queue.hours',
    seconds: 'queue.seconds',
    and: 'queue.and',
}) {
    let strDate = '';
    let sec = timeInMs / 1000;
    let hours = Math.floor(sec / 3600);
    let days = Math.floor(hours / 24);
    hours -= days * 24;

    sec = Math.round(sec % 3600);
    let min = Math.floor(sec / 60);
    sec = Math.round(sec % 60);

    // handle automatic translation
    if(typeof queue === 'string') {
        return t(queue, {
            days,
            hours,
            minutes: min,
            seconds: sec,
        });
    }

    if(days > 0) {
        strDate += days.toString() + ' ' + t(queue.days, { count: days }) + ' ';
    }

    if (hours > 0) {
        strDate += hours.toString() + ' ' + t(queue.hours, { count: hours }) + ' ';
    }

    strDate += min.toString() + ' ' + t(queue.minutes, { count: min });
    if (displaySeconds) {
        strDate += ' ' + t(queue.and) + ' ' + sec.toString() + ' ' + t(queue.seconds, { count: sec });
    }
    return strDate;
}

/**
* Return date (ms) in date readable in str.
* @param timeInMs  time in ms
*/
export function getDate(date, lang) {
    let dateNow = Date.now();
    let opening = new Date(dateNow + date);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };

    let strTime = opening.toLocaleDateString(lang, options)
    return strTime;
}

/**
* Return text tranlation according dictTrad (or default trad), the language
* @param customText 
* @param lang 
* @param key 
* @param t 
*/
export function getTranslationOrDefault(customText, lang, key, t) {
    let trad_lang = lang.toLowerCase()
    if (!customText[trad_lang]) {
        return t('queue.waiting_text.' + key);
    }

    if (!customText[trad_lang][key]) {
        return t('queue.waiting_text.' + key);
    }

    return customText[trad_lang][key];
}

export function UUID(){
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

export function isDescendant(parent, child) {
    var node = child;
    while (node != null) {
        if (node === parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
};

//to disable the autocomplete, need "randomString" for Chrome, "off" otherwise
export const autocompleteDisabled = () => window?.navigator?.userAgent?.toLocaleLowerCase().includes('chrome') ? "randomString" : "off"; 